import {FormControl, FormField, FormItem, FormLabel, FormMessage} from "@/components/ui/form";
import {cn} from "@/lib/utils";
import {Input} from "@/components/ui/input";
import {RadioGroup, RadioGroupItem} from "@/components/ui/radio-group";


export default function CWFRadioGroup({ control, name, className, label, placeholder, options, orientation = "vertical", ...props}){
    return (
        <FormField
            control={control}
            name={name}
            render={({field}) => (
                <FormItem className={cn("grid w-full items-center h-max gap-1.5 space-y-0", className)}>
                    {label && <FormLabel>{label}</FormLabel>}
                    <FormControl>
                        <RadioGroup
                            onValueChange={field.onChange}
                            defaultValue={field.value}
                            {...props}
                            className={orientation === "horizontal" && "flex gap-8"}
                        >
                            {options.map((option, index) => (
                                <FormItem key={index} className="flex items-center gap-2 space-y-0">
                                    <FormControl>
                                        <RadioGroupItem value={option.value} />
                                    </FormControl>
                                    <FormLabel className="font-normal cursor-pointer">
                                        {option.label}
                                    </FormLabel>
                                </FormItem>
                            ))}
                        </RadioGroup>
                    </FormControl>
                    <FormMessage />
                </FormItem>
            )}
        />
    );
}